import { Cookies } from 'react-cookie';

export const getCookie = (name) => {
  const cookie = new Cookies();
  const value = cookie.get(name);
  return value || '';
};

export const setCookie = (name, value, options = {}) => {
  const cookie = new Cookies();
  cookie.set(name, value, {
    path: '/',
    maxAge: 60 * 60 * 24 * 30,
    secure: true,
    ...options,
  });
};

export const removeCookie = (name, options = { path: '/' }) => {
  const cookie = new Cookies();
  cookie.remove(name, options);
  cookie.remove(name, { ...options, path: '/admin' });
};

export const removeSingleCookie = (name) => {
  const cookie = new Cookies();
  cookie.remove(name);
};

export const removeAppCookies = (isUser = false) => {
  if (isUser) {
    removeCookie('access-token-user');
  } else {
    removeCookie('access-token');
    removeCookie('one_signal_id');
    removeCookie('cache-key');
    removeCookie('tenant-key');
  }
};

export const setLocalStorage = (name, value) => {
  localStorage.setItem(name, value);
};

export const getLocalStorage = (name) => {
  const value = localStorage.getItem(name);
  return value || '';
};

export const setSessionStorage = (name, value) => {
  sessionStorage.setItem(name, value);
};

export const getSessionStorage = (name) => {
  const value = sessionStorage.getItem(name);
  return value || '';
};
